import { ApiClient } from "./api.ts";

export interface OrganizationInvite {
    id: string;
    organization_id: string;
    email: string;
    role: string;
    status: 'pending' | 'accepted' | 'expired' | 'revoked';
    token: string;
    created_at: string;
    expires_at: string;
}

export interface InvitePublicInfo {
    invite: OrganizationInvite;
    organization: {
        id: string;
        name: string;
    };
}

export interface OrganizationMember {
    id: string;
    organization_id: string;
    user_id: string;
    user_role: string;
    email: string;
    details: {
        display_name: string;
    }
}

export class OrganizationInvitesService {
    private static instance: OrganizationInvitesService;
    private api = ApiClient.getInstance();

    private constructor() { }

    public static getInstance(): OrganizationInvitesService {
        if (!OrganizationInvitesService.instance) {
            OrganizationInvitesService.instance = new OrganizationInvitesService();
        }
        return OrganizationInvitesService.instance;
    }

    public async inviteUser(orgId: string, email: string, role: string = 'member'): Promise<OrganizationInvite> {
        return await this.api.request<OrganizationInvite>(`/organization/${orgId}/invites`, {
            method: 'PUT',
            body: JSON.stringify({ email, role }),
            toast: { success: 'Invitation sent successfully' }
        }) as OrganizationInvite;
    }

    public async getInvites(orgId: string): Promise<OrganizationInvite[]> {
        return await this.api.request<OrganizationInvite[]>(`/organization/${orgId}/invites`) as OrganizationInvite[];
    }

    public async revokeInvite(orgId: string, inviteId: string): Promise<void> {
        await this.api.request(`/organization/${orgId}/invites/${inviteId}`, {
            method: 'DELETE'
        });
    }

    public async getInvitePublic(token: string): Promise<InvitePublicInfo> {
        return await this.api.request<InvitePublicInfo>(`/invites/${token}`) as InvitePublicInfo;
    }

    public async acceptInvite(token: string): Promise<any> {
        return await this.api.request(`/invites/${token}/accept`, {
            method: 'PUT'
        });
    }

    public async updateMemberRole(orgId: string, userId: string, role: string): Promise<void> {
        await this.api.request(`/organization/${orgId}/users/${userId}`, {
            method: 'PATCH',
            body: JSON.stringify({ role })
        });
    }

    public async getMembers(orgId: string): Promise<OrganizationMember[]> {
        return await this.api.request<OrganizationMember[]>(`/organization/${orgId}/users`) as OrganizationMember[];
    }

    public async removeMember(orgId: string, userId: string): Promise<void> {
        await this.api.request(`/organization/${orgId}/users/${userId}`, {
            method: 'DELETE'
        });
    }
}
